// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"time-left_scroll-black__3tKRZ","time-left":"time-left_time-left__T_xdy"};